"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeStructureTensorGLFilter extends _ShapeBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision highp float;
        uniform sampler2D t_tex;
        uniform vec2 screenSize;
        varying highp vec2 v_uv;

        void main()
        {
            vec2 pos = gl_FragCoord.xy * screenSize;
            float dx = screenSize.x;
            float dy = screenSize.y;

            vec3 m00 =  texture2D(t_tex, pos + vec2(-dx,-dy)).rgb;
            vec3 m01 =  texture2D(t_tex, pos + vec2(0,-dy)).rgb;
            vec3 m02 =  texture2D(t_tex, pos + vec2(dx,-dy)).rgb;

            vec3 m10 =  texture2D(t_tex, pos + vec2(-dx,0)).rgb;
            vec3 m12 =  texture2D(t_tex, pos + vec2(dx,0)).rgb;

            vec3 m20 =  texture2D(t_tex, pos + vec2(-dx,dy)).rgb;
            vec3 m21 =  texture2D(t_tex, pos + vec2(0,dy)).rgb;
            vec3 m22 =  texture2D(t_tex, pos + vec2(dx,dy)).rgb;

            vec3 u = (
                    -1.0 * m00 +
                    -2.0 * m10 +
                    -1.0 * m20 +
                    1.0 * m02 +
                    2.0 * m12 +
                    1.0 * m22
                    ) / 4.0;

            vec3 v = (
                    -1.0 * m00 +
                    -2.0 * m01 +
                    -1.0 * m02 +
                    1.0 * m20 +
                    2.0 * m21 +
                    1.0 * m22
                    ) / 4.0;

            vec3 dst = vec3(
                            dot(u, u),  // guaranteed to be positive
                            dot(v, v),  // guaranteed to be positive
                            dot(u, v)	// may be negative
                            );
            dst.xy = sqrt(dst.xy);
            dst.z = (dst.z < 0.0) ? -sqrt(-dst.z) : sqrt(dst.z);
            dst.z = 0.5*(dst.z+1.0);
            gl_FragColor = vec4(dst.xyz, 1.0); //texture2D(t_tex, v_uv).rgb;
        }
        `;
    super(fsSource);
  }

}

exports.default = ShapeStructureTensorGLFilter;